import loadable from '@loadable/component'

export const LazyInstagramEmbed = loadable(() => import('./Instagram.web'))
